<div class="global-filter">
	<i class="pi pi-search" style="margin:4px 4px 0 0"></i>
	<input type="text" pInputText size="50" placeholder="{{inputPlaceholder}}" (input)="keyUp.next($event)"
		style="width:auto">
</div>